import React from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

/**
 * Save button component with config-driven behavior
 * 
 * @param {boolean} disabled - Whether the button is disabled
 * @param {function} onClick - Save button click handler
 * @param {function} onDraftClick - Draft button click handler
 * @param {boolean} isInline - If true, adjusts height for inline display
 * @param {boolean} showDraftButton - Whether to show the draft button (from config)
 * @param {boolean} canEdit - Whether user has edit permissions
 */
const SaveButton = ({ 
  disabled, 
  onClick, 
  onDraftClick,
  isInline, 
  showDraftButton = false,
  canEdit = true,
}) => {
  const baseSx = { 
    minWidth: { xs: '120px', sm: '150px' }, 
    width: { xs: '100%', sm: 'auto' },
    margin: 'auto 0',
    fontSize: { xs: '0.875rem', sm: '0.9375rem' }
  };

  const draftSx = { 
    ...baseSx, 
    marginRight: { xs: '8px', sm: '10px' }
  };

  if (isInline) {
    baseSx.height = '80%';
    draftSx.height = '80%';
  }

  if (!canEdit) {
    return null;
  }

  // Show both Save as Draft and Save Changes buttons when configured
  if (showDraftButton && onDraftClick) {
    return (
      <Box 
        display="flex" 
        flexDirection={{ xs: 'column', sm: 'row' }}
        gap={{ xs: 1, sm: 0 }}
        width={{ xs: '100%', sm: 'auto' }}
      >
        <Button 
          variant="outlined" 
          disabled={disabled} 
          sx={draftSx} 
          onClick={onDraftClick}
        >
          Save as Draft
        </Button>
        <Button 
          variant="contained" 
          disabled={disabled} 
          sx={baseSx} 
          onClick={onClick}
        >
          Save Changes
        </Button>
      </Box>
    );
  }

  // Default: single Save Changes button
  return (
    <Button 
      variant="contained" 
      disabled={disabled} 
      sx={baseSx} 
      onClick={onClick}
    >
      Save Changes
    </Button>
  );
};

export default SaveButton;

